// Configuración de los CTA/formularios por sección (combos y campos personalizados)
export const LEAD_CONFIGS = {
  "/": {
    accent: "#FF8A80",
    eyebrow: "Sumáte a la aventura",
    title: "¿Empezamos el viaje juntos?",
    text: "Déjanos tus datos y te decimos cómo vivir Anto&Bella por el Mundo desde la primera fila. Sintoniza la ruta en TV abierta en la zona Occidente de México. Si te la pierdes, la conversación sigue en Singulativa TV Broadcasting.",
    combos: [
      "Quiero ser Believer (gratis)",
      "Información del Área VIP",
      "Soy marca / patrocinador",
      "Prensa y medios",
    ],
    extra: [
      { name: "ciudad", label: "Ciudad", placeholder: "¿Desde dónde nos ves?" },
    ],
  },
  "/la-ruta": {
    accent: "#81D4FA",
    eyebrow: "La Ruta",
    title: "¿Qué destino sueñas ver?",
    text: "Cuéntanos tu parada favorita o propón el próximo destino de la ruta.",
    combos: [
      "Sugerir un destino",
      "Info de la ruta y sellos",
      "Colaboración de viaje / turismo",
    ],
    extra: [
      { name: "destino", label: "Destino favorito", placeholder: "Tu destino soñado" },
    ],
  },
  "/el-formato": {
    accent: "#A8E6CF",
    eyebrow: "El Formato",
    title: "¿Colaboramos en la producción?",
    text: "Productoras, creadores y medios: hablemos del formato de seis actos.",
    combos: [
      "Producción / colaboración",
      "Prensa y medios",
      "Licenciamiento del formato",
    ],
    extra: [
      { name: "organizacion", label: "Organización", placeholder: "Tu productora o medio" },
    ],
  },
  "/episodios": {
    accent: "#A8E6CF",
    eyebrow: "Episodios",
    title: "No te pierdas ningún estreno",
    text: "Elije una parada y deja que la conversación siga. Te avisamos por whatsapp o IG y te mandamos adelantos exclusivos. Todos los episodios siguen la misma estructura. Un formato fijo, como un itinerario de vuelo, para que siempre sepas qué sigue.",
    combos: [
      "Avísame de los estrenos",
      "Prensa y medios",
      "Colaboración de contenido",
    ],
    extra: [
      { name: "episodio", label: "Episodio favorito", placeholder: "¿Cuál esperas más?" },
    ],
  },
  "/la-app": {
    accent: "#FF8A80",
    eyebrow: "La App",
    title: "Quiero probar la app",
    text: "Para mirar juntos, aunque estén en lugares distintos. Todo es una invitación visual: sin cuentas, datos ni botones que prometan más de lo que pueden hacer. Sé de los primeros en la beta de segunda pantalla, mapa y pasaporte digital.",
    combos: [
      "Quiero la beta de la app",
      "Enviar una sugerencia",
      "Soporte técnico",
    ],
    extra: [
      { name: "dispositivo", label: "Dispositivo", placeholder: "iOS / Android" },
    ],
  },
  "/anto-bella": {
    accent: "#FF8A80",
    eyebrow: "Anto & Bella",
    title: "¿Invitas a Anto & Bella?",
    text: "Colaboraciones, entrevistas y apariciones del dúo.",
    combos: [
      "Invitar a Anto & Bella",
      "Prensa / entrevista",
      "Colaboración creativa",
    ],
    extra: [
      { name: "motivo", label: "Motivo", placeholder: "Cuéntanos la idea" },
    ],
  },
  "/believers": {
    accent: "#FF8A80",
    eyebrow: "Believers",
    title: "Únete a la comunidad Believer",
    text: "Es gratis. Déjanos tu correo y te avisamos de cada estreno y sorteo.",
    combos: [
      "Unirme a Believers (gratis)",
      "Organizar un meet-up",
      "Comunidad / voluntariado",
    ],
    extra: [
      { name: "ciudad", label: "Ciudad", placeholder: "¿Desde dónde nos ves?" },
    ],
  },
  "/vip": {
    accent: "#E8C547",
    eyebrow: "Área VIP",
    title: "Quiero el acceso VIP",
    text: "Episodios sin cortes, detrás de cámaras y sorteos exclusivos.",
    combos: [
      "Información del Área VIP",
      "Regalar una membresía",
      "Soporte de suscripción",
    ],
    extra: [
      { name: "believer", label: "¿Ya eres Believer?", placeholder: "Sí / No" },
    ],
  },
  "/en-vivo": {
    accent: "#FF8A80",
    eyebrow: "En Vivo",
    title: "Recordatorio de transmisión",
    text: "Te avisamos antes de que empiece cada transmisión en vivo.",
    combos: [
      "Recordatorio de transmisión",
      "Prensa y medios",
      "Reportar un problema técnico",
    ],
    extra: [
      { name: "zona", label: "Zona / región", placeholder: "¿Desde qué zona ves TV?" },
    ],
  },
};
